<template>
  <form class="ecommerce-form action-buttons-fixed" novalidate>
    <div class="row">
      <div class="col">
        <section class="card card-modern card-big-info">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-2-5 col-xl-1-5">
                <i class="card-big-info-icon bx bx-user"></i>
                <h2 class="card-big-info-title">Zahtjev za promjenom podataka</h2>
              </div>
              <div class="col-lg-3-5 col-xl-4-5">
                <div class="row form-group">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="first-name">Ime</label>
                      <input type="text" id="first-name" class="form-control form-control-modern" readonly v-model="request.firstName">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label
                        :class="{ 'text-danger': request.currentData.firstName != request.firstName }"
                      >
                        Ime
                      </label>
                      <input type="text" id="first-name" class="form-control form-control-modern" readonly v-model="request.currentData.firstName">
                    </div>
                  </div>
                </div>

                <div class="row form-group">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="last-name">Prezime</label>
                      <input type="text" id="last-name" class="form-control form-control-modern" readonly v-model="request.lastName">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label :class="{ 'text-danger': request.currentData.lastName != request.lastName }">
                        Prezime
                      </label>
                      <input type="text" id="first-name" class="form-control form-control-modern" readonly v-model="request.currentData.lastName">
                    </div>
                  </div>
                </div>

                <div class="row form-group">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="first-name">Drzava</label>
                      <input type="text" id="first-name" class="form-control form-control-modern" readonly v-model="request.country">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label
                        :class="{ 'text-danger': request.currentData.country != request.country }"
                      >
                        Drzava
                      </label>
                      <input type="text" id="first-name" class="form-control form-control-modern" readonly v-model="request.currentData.country">
                    </div>
                  </div>
                </div>
                

                <div class="row form-group">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="last-name">Grad</label>
                      <input type="text" id="last-name" class="form-control form-control-modern" readonly v-model="request.town">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label :class="{ 'text-danger': request.currentData.town != request.town }">
                        Grad
                      </label>
                      <input type="text" id="last-name" class="form-control form-control-modern" readonly v-model="request.currentData.town">
                    </div>
                  </div>
                </div>

                <div class="row form-group">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="first-name">Zip kôd</label>
                      <input type="text" id="first-name" class="form-control form-control-modern" readonly v-model="request.zipCode">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label :class="{ 'text-danger': request.currentData.zipCode != request.zipCode }">
                        Zip kôd
                      </label>
                      <input type="text" id="first-name" class="form-control form-control-modern" readonly v-model="request.currentData.zipCode">
                    </div>
                  </div>
                </div>

                <div class="row form-group">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="last-name">Adresa</label>
                      <input type="text" id="last-name" class="form-control form-control-modern" readonly v-model="request.address">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label :class="{ 'text-danger': request.currentData.address != request.address }">
                        Adresa
                      </label>
                      <input type="text" id="last-name" class="form-control form-control-modern" readonly v-model="request.currentData.address">
                    </div>
                  </div>
                </div>

                <div class="row form-group">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="first-name">Broj telefona</label>
                      <input type="text" id="first-name" class="form-control form-control-modern" readonly v-model="request.phoneNumber">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label :class="{ 'text-danger': request.currentData.phoneNumber != request.phoneNumber }">
                        Broj telefona
                      </label>
                      <input type="text" id="first-name" class="form-control form-control-modern" readonly v-model="request.currentData.phoneNumber">
                    </div>
                  </div>
                </div>

                <div class="row form-group">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="last-name">Email adresa</label>
                      <input type="text" id="last-name" class="form-control form-control-modern" readonly v-model="request.email">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label :class="{ 'text-danger': request.currentData.email != request.email }">
                        Email adresa
                      </label>
                      <input type="text" id="last-name" class="form-control form-control-modern" readonly v-model="request.currentData.email">
                    </div>
                  </div>
                </div>
                
                <div class="row form-group">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="first-name">Interesna područja</label>
                      <treeselect
                        v-model="request.interestsAreasIds"
                        :multiple="true"
                        :options="areas"
                        :show-count="true"
                        disabled
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label :class="{ 'text-danger': request.currentData.interestsAreasIds != request.interestsAreasIds }">
                        Interesna područja
                      </label>
                      <treeselect
                        v-model="request.currentData.interestsAreasIds"
                        :multiple="true"
                        :options="areas"
                        :show-count="true"
                        disabled
                      />
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="action-buttons d-flex justify-content-end">
      <div class="d-flex gap-3">
        <button
          @click="decline()"
          type="button"
          class="btn btn-danger btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
        >
          <i class="bx bxs-hand text-4 me-2"></i> Poništi
        </button>
        <button
          @click="approve()"
          type="button"
          class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
        >
          <i class="bx bx-check text-4 me-2"></i> Odobri
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import api from '@/services/api';
import { translations } from '@/mixins';

export default {
  name: 'EditUser',
  components: { Treeselect },
  mixins: [translations],
  data() {
    return {
      password: '',
      confirmPassword: '',
      sameAsBilling: false,
    };
  },
  computed: {
    request() {
      return this.$store.getters.getPersonalDataChangeRequest;
    },
    areas() {
      return this.$store.getters.getInterestsAreas.map((item) => {
        return {
          id: item.id,
          label: item.title,
        };
      });
    },
  },
  methods: {
    approve() {
      api.approvePersonalRequest(this.request.id).then((response) => {
        this.$toast.info(response.data.info);
      }).catch((err) => {
        this.$toast.error(err.response.data.info);
      }).finally(() => {
        this.$router.push({ name: 'PersonalDataChangeRequests' });
      });
    },
    decline() {
      api.declinePersonalRequest(this.request.id).then((response) => {
        this.$toast.info(response.data.info);
      }).catch((err) => {
        this.$toast.error(err.response.data.info);
      }).finally(() => {
        this.$router.push({ name: 'PersonalDataChangeRequests' });
      });
    },
  },
  mounted() {
    this.$store.dispatch('getInterestsAreas', { sortBy: 'title', isSortAscending: true, retrieveAll: true });
    this.$store.dispatch('getPersonalDataChangeRequest', parseInt(this.$route.params.id));
  },
}
</script>
<style lang="scss" scoped>
.form-group {
  padding-bottom: 10px;

  &:nth-child(5) {
    border-bottom: 1px solid #f3f3f3;
  }
}

.btn-danger {
  color: #fff !important;
}
</style>